import { render, staticRenderFns } from "./Iot.vue?vue&type=template&id=2bafeeaa&scoped=true&"
import script from "./Iot.vue?vue&type=script&lang=js&"
export * from "./Iot.vue?vue&type=script&lang=js&"
import style0 from "./Iot.vue?vue&type=style&index=0&id=2bafeeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafeeaa",
  null
  
)

export default component.exports